import React, { useEffect, useState } from "react"
import {
    Text, View, Image, StyleSheet, ScrollView,
    TouchableOpacity, BackHandler, Linking, ImageBackground, Pressable
} from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader"
import AppTheme from "../../AppTheme";
import * as Redux from "../../utils/services/redux/commonRedux";
import * as commonUtils from "../../utils/services/CommonUtils";
import * as MoengageUtils from "../../utils/services/webapp-services/MoengageUtils";
import * as AlertService from "../../utils/services/AlertLoaderService";
import { Ampersand } from "../../utils/constants/AppConstants";
import { store } from "../../store/store";
import { AayuCardDesign } from "../../utils/widgets/AayuCard/AayuCardDesign";
import { doPost } from "../../utils/services/api/API";
import AppStyles from "../../AppStyles";
import * as CommonUtils from "../../utils/services/CommonUtils";
import { PrimaryCTA } from "../../utils/widgets/CommonCTA";
import { ScreenRoute } from "../../utils/constants/ScreenRouteConstant";
import TextStyle from "../../TextStyle";

const aayuCardBenefitsList = [
    'E-consults & follow ups for full family',
    'Valid for 12 months from date of purchase',
    'Free for all health problems',
    'Save money on your family\'s helthcare'
]

const AayuCardListing = (props) => {

    const [aayuPlanList, updateAayuPlanList]: any[] = useState([]);
    const [expanded, updateExpanded] = useState(-1);
    const [selectedIndex, updateSelectedIndex] = useState(0);


    const getAayuCardPlans = () => {
        AlertService.loaderModal.setLoader(true);
        var params = { 'ln': 'en' };
        doPost('service_config/get_configurations', params).then(
            (response: any) => {
                AlertService.loaderModal.setLoader(false);
                let plans: any = response.plans.filter(item => item.canPurchase === true)
                updateAayuPlanList(plans);
                Redux.updateReduxAayuCardPlans(plans);
            }
        )
    }

    useEffect(() => {
        const reduxState = store.getState();
        if ((reduxState.aayuPlans && reduxState.aayuPlans.length == 0) || aayuPlanList.length == 0)
            getAayuCardPlans()
        else updateAayuPlanList(reduxState.aayuPlans);
    })

    return (
        <View>
            <View style={{ position: 'fixed', zIndex: 10, backgroundColor: 'white', width: AppTheme.appWidth }}>
                <CommonHeader navigation={props.navigation} title='Aayu Card Plans'></CommonHeader>
            </View>
            <ScrollView style={{ marginTop: AppTheme.headerHeight + 7 }}>
                <View style={{ backgroundColor: AppTheme.color.green.primary }}>
                    <Text style={styles.buyLabel}>
                        Buy Aayu card subscription {Ampersand} save heavily!</Text>
                </View>
                <Text style={styles.purchaseLabel}>
                    After purchasing the Aayu subscription plan, this consultation will be covered under the plan.</Text>

                <View style={{ marginBottom: 150 }}>
                    {
                        aayuPlanList.map((aayuPlan, index) => (

                            <View key={index} style={{ alignItems: "center", marginTop: 80 }}>
                                <Pressable onPress={() => {
                                    updateSelectedIndex(index);
                                }} style={{
                                    position: "absolute", zIndex: 10, top: -60, borderRadius: 8,
                                    borderTopWidth: selectedIndex === index ? 4 : 0,
                                    borderLeftWidth: selectedIndex === index ? 4 : 0,
                                    borderRightWidth: selectedIndex === index ? 3 : 0,
                                    borderBottomWidth: selectedIndex === index ? 4.8 : 0,

                                    borderColor: selectedIndex === index ? AppTheme.color.aayuCardColors.premiumSecondary : ''
                                }}>
                                    <AayuCardDesign aayuCardPlan={aayuPlanList[index]} margin={32} radius={8} />
                                </Pressable>
                                <View style={{
                                    position: 'absolute', width: AppTheme.appWidth, height: expanded == index ? 318 : 193,
                                    bottom: 14,
                                }}>
                                </View>
                                <View style={{
                                    borderColor: AppTheme.color.purple.border, borderRadius: 8, borderWidth: 1, backgroundColor: AppTheme.color.white,
                                    width: AppTheme.appWidth - 32, marginTop: index === 0 ? 5 : 1,
                                    alignContent: "flex-end", alignItems: "center", paddingBottom: 12
                                }}>

                                    <Pressable onPress={() => { updateExpanded(expanded == index ? -1 : index) }}
                                        style={[AppStyles.flexRowCenter, { marginTop: 100, paddingBottom: 5, paddingTop: 16 }]}>
                                        <Text style={[AppStyles.f14, { color: AppTheme.color.primary, paddingRight: 4 }]}>
                                            {expanded == index ? 'VIEW LESS' : "VIEW MORE"}</Text>
                                        <View style={{ borderRadius: 10, padding: 2, backgroundColor: AppTheme.color.primary }}>
                                            <MaterialIcons name="keyboard-arrow-up" color={AppTheme.color.white} /></View>
                                    </Pressable>
                                    {
                                        expanded == index ? <View>
                                            <Text style={[AppStyles.f16, AppStyles.mx12, AppStyles.my8,
                                            { fontSize: 12, fontWeight: '600', width: AppTheme.appWidth * 0.7, color: AppTheme.color.black }]}>
                                                What does this plan include?</Text>
                                            {aayuCardBenefitsList.map((benefits, benefitIndex) => (
                                                <Pressable key={benefitIndex + 10} onPress={() => { updateExpanded(-1) }}
                                                    style={{}}>
                                                    <View style={{ flex: 1, justifyContent: 'flex-start', flexDirection: 'row', padding: 6 }}>
                                                        <Text style={[AppStyles.f16, { width: 20 }]}> &#x2713;</Text>
                                                        <Text style={[AppStyles.f16, { fontSize: 12, width: AppTheme.appWidth * 0.7, color: AppTheme.color.black }]}>
                                                            {benefitIndex == 0 ? aayuPlanList[index]['consultations'] + benefits : benefits}</Text></View>
                                                </Pressable>
                                            ))}
                                        </View> : <View />
                                    }
                                </View>
                            </View>
                        ))
                    }
                </View>
            </ScrollView>
            <View style={{
                bottom: 0, width: AppTheme.appWidth, position: 'fixed',
                backgroundColor: AppTheme.color.white, shadowRadius: 3, shadowOpacity: 2
            }}>
                <View style={[AppStyles.submitBtn]}>
                    <PrimaryCTA text={`ACTIVATE THIS PLAN`}
                        onPress={() => {
                            Redux.updateSelectedAayucard(aayuPlanList[selectedIndex]);
                            MoengageUtils.trackMoengageEvents('choose_aayu_card_with_econsult')
                            global.appHandledBackpress = true;
                            props.navigation.pop();
                            props.navigation.pop();
                            props.navigation.navigate(ScreenRoute.payment_online, {
                                serviceParams: aayuPlanList[selectedIndex],
                                serviceName: props.route.params.serviceName, onBackPressRoute: props.route.params.onBackPressRoute
                            })
                        }} />
                </View>

                <View style={[AppStyles.flexRowCenter, {
                    marginVertical: 20, marginHorizontal: 30,
                    paddingVertical: 4
                }]}><Text style={[TextStyle.text14, {
                    color: AppTheme.color.grey.text
                }]}>Don't worry, this payment is completely safe</Text>
                    <Image source={{
                        uri: CommonUtils.getImagePath('/images/secure_payment_ic.svg'),
                        width: 12.3, height: 14
                    }} />
                </View>

            </View>
        </View >
    )
}

export default AayuCardListing;

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    purchaseLabel: { fontSize: 16, flexWrap: "wrap", margin: 16, lineHeight: 24 },
    buyLabel: { color: AppTheme.color.white, fontSize: 16, lineHeight: 24, padding: 16 }


}))
